import {
    container,
    mlAuto,
    section,
    main,
    mainRaised,
    title,
    cardTitle,
    roseColor,
    dashed
} from "../../material-kit-pro-react.jsx";

import tooltipsStyle from "../../material-kit-pro-react/tooltipsStyle.jsx";
import imagesStyles from "../../material-kit-pro-react/imagesStyles.jsx";
import customSelectStyle from "../../material-kit-pro-react/customSelectStyle.jsx";

const imgRaised = imagesStyles.imgRaised;
const rounded = imagesStyles.imgRounded;
const imgFluid = imagesStyles.imgFluid;

const productStyle = {
    mlAuto,
    main,
    ...imagesStyles,
    ...customSelectStyle,
    ...tooltipsStyle,
    container: {
        ...container,
        zIndex: 2
    },
    mainRaised: {
        ...mainRaised
    },
    section: {
        ...section,
        padding: "70px 0px"
    },
    title: {
        ...title,
        marginBottom: 0
    },
    sectionGray: {
        background: "#e5e5e5"
    },
    mainPrice: {
        margin: "10px 0px 25px"
    },
    mainPriceMini: {
        margin: "5px 0px 5px",
        color: "green",
        fontWeight: "500"
    },
    explanatoryNote: {
        margin: "10px 0px 25px",
        color: 'red'
    },
    textCenter: {
        textAlign: "center!important"
    },
    features: {
        paddingTop: "30px"
    },
    productPage: {
        backgroundColor: "#eee",
        "& $mainRaised": {
            margin: "-40vh 0 0",
            padding: "40px"
        },
        "& .image-gallery-slide img": {
            borderRadius: "3px",
            height: "auto"
        },
        "& .image-gallery-swipe": {
            margin: "30px 0px",
            overflow: "hidden",
            width: "100%",
            height: "auto",
            textAlign: "center"
        },
        "& .image-gallery-thumbnails > .image-gallery-thumbnails-container a": {
            "&.active > div": {
                opacity: "1",
                borderColor: "#DDDDDD"
            },
            "& > div": {
                width: "80%",
                maxWidth: "85px",
                margin: "0 auto",
                padding: "8px",
                display: "block",
                border: "1px solid transparent",
                background: "transparent",
                borderRadius: "3px",
                opacity: ".8"
            },
            "& > div img": {
                borderRadius: "3px",
                width: "100%",
                height: "auto",
                textAlign: "center"
            }
        }
    },
    titleRow: {
        marginTop: "-8vh"
    },
    floatRight: {
        float: "right!important"
    },
    pageHeader: {
        minHeight: "60vh",
        maxHeight: "600px",
        height: "auto",
        backgroundPosition: "top center"
    },
    relatedProducts: {
        marginTop: "50px",
        "& $title": {
            marginBottom: "80px"
        }
    },
    pickSize: {
        marginTop: "50px"
    },
    pullRight: {
        float: "right"
    },
    pullCenter: {
        display: "inline-block",
        float: "none"
    },
    cardCategory: {
        textAlign: "center",
        marginTop: "10px"
    },
    cardTitle: {
        ...cardTitle,
        textAlign: "center"
    },
    cardDescription: {
        textAlign: "center",
        color: "#999"
    },
    textRose: {
        color: roseColor
    },
    justifyContentBetween: {
        justifyContent: "space-between!important"
    },
    socialFeed: {
        "& p": {
            display: "table-cell",
            verticalAlign: "top",
            overflow: "hidden",
            paddingBottom: "10px",
            maxWidth: 300
        },
        "& i": {
            fontSize: "20px",
            display: "table-cell",
            paddingRight: "10px"
        }
    },
    img: {
        width: "20%",
        marginRight: "5%",
        marginBottom: "5%",
        float: "left"
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto"
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    left: {
        float: "left!important",
        display: "block"
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right"
    },
    icon: {
        top: "3px",
        width: "18px",
        height: "18px",
        position: "relative"
    },
    imgRaised,
    imgFluid,
    rounded,
    alignCenter: {
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center"
    },



    dashed,
    vecInline: {
        display: "flex",
        marginTop: "10px"
    },
    vecLabelContainer: {
        paddingLeft: "7px"
    },
    vecLabel: {
        position: "absolute",
        marginTop: "23px"
    },
    vecLabel2: {
        position: "absolute",
        "@media (min-width: 700px)": { // Show in desktop
            marginTop: "8px"
        },
        "@media (max-width: 700px)": { // Show in mobile
            marginTop: "7px"
        },
    },
    vecMaxPersInput: {
        border: "1px solid #dbdbdb",
        borderRadius: "2px",
        verticalAlign: "middle",
        padding: "8px 0px 4px 13px",
        "& input": {
            fontSize: "18px",
            marginLeft: "7px"
        }
    },
    vecMaxPContainer: {
        paddingTop: "10px",
        margin: "0"
    },
    noPaddingLeft: {
        paddingLeft: "0"
    },
    noPaddingRight: {
        paddingRight: "0"
    },
    vecButtonsContainer: {
        paddingTop: "10px"
    },
    vecPriceMiniContainer: {
        "@media (min-width: 700px)": { // Show in desktop
            paddingTop: "36px"
        },
        "@media (max-width: 700px)": { // Show in mobile
            paddingTop: "10px"
        },
        paddingBottom: "15px"
    },
    vecFullLeaseAdv: {
        margin: "5px 0px 5px",
        color: "red",
        fontWeight: "500"
    },
    vecCardDetails: {
        paddingBottom: "0",
        "& div": {
            backgroundColor: "#f5f5f5",
            padding: "10px"
        }
    },
    vecUlLeft: {
        paddingLeft: "0",
        // marginInlineStart: "-38px"
    },
    advertisementTextDanger: {
        marginBottom: "0",
        marginTop: "7px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            top: "8px",
            lineHeight: "0"
        },
        color: 'red'
    },
    advertisementTextSuccess: {
        marginBottom: "0",
        marginTop: "7px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            top: "8px",
            lineHeight: "0"
        },
        color: 'green'
    }
};

export default productStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/productStyle.jsx